import {
  getDashboardLicensesControllerListQueryKey,
  getDashboardLicensesControllerStatsQueryKey,
} from "@/api/__generated__/dashboard-licenses/dashboard-licenses";
import { MessageKey } from "@/i18n";
import {
  LicenseAgeLimitType,
  LicenseDuration,
  LicenseGenderRestriction,
  LicenseStatus,
  PurchasedLicenseApprovalStatus,
  PurchasedLicenseStatus,
} from "@/types";

export const LICENSES_INVALIDATE_KEYS = [
  getDashboardLicensesControllerListQueryKey(),
  getDashboardLicensesControllerStatsQueryKey(),
];

export const LICENSE_STATUS_LABELS: { [key in LicenseStatus]: MessageKey } = {
  active: "license.status.active",
  inactive: "license.status.inactive",
};

export const PURCHASED_LICENSE_STATUS_LABELS: { [key in PurchasedLicenseStatus]: MessageKey } = {
  active: "license.purchasedLicenseStatus.active",
  inactive: "license.purchasedLicenseStatus.inactive",
  upcoming: "license.purchasedLicenseStatus.upcoming",
  expired: "license.purchasedLicenseStatus.expired",
};

export const PURCHASED_LICENSE_APPROVAL_STATUS_LABELS: {
  [key in PurchasedLicenseApprovalStatus]: MessageKey;
} = {
  approved: "license.purchasedLicenseApprovalStatus.approved",
  declined: "license.purchasedLicenseApprovalStatus.declined",
  pending: "license.purchasedLicenseApprovalStatus.pending",
  validating: "license.purchasedLicenseApprovalStatus.validating",
  waitingForProof: "license.purchasedLicenseApprovalStatus.waitingForProof",
  proofDeclined: "license.purchasedLicenseApprovalStatus.proofDeclined",
};

export const LICENSE_DURATION_LABELS: { [key in LicenseDuration]: MessageKey } = {
  "1month": "license.duration.1month",
  "3months": "license.duration.3months",
  "12months": "license.duration.12months",
  untilEndOfCurrentYear: "license.duration.untilEndOfCurrentYear",
  specificPeriod: "license.duration.specificPeriod",
  "1time": "license.duration.1time",
};

export const LICENSE_AGE_LIMIT_TYPE_LABELS: { [key in LicenseAgeLimitType]: MessageKey } = {
  year: "license.form.ageLimitType.year",
  age: "license.form.ageLimitType.age",
};

export const LICENSE_GENDER_RESTRICTION_LABELS: { [key in LicenseGenderRestriction]: MessageKey } =
  {
    male: "license.genderRestriction.male",
    female: "license.genderRestriction.female",
    anyone: "license.genderRestriction.anyone",
  };
